"use client";

import { useMemo, useState } from "react";
import { Field, Stat, fmtMoney, fmtPct } from "../ToolUi";

export default function CalculatorClient() {
  const [pointsPerDollar, setPointsPerDollar] = useState("5");
  const [pointsForReward, setPointsForReward] = useState("500");
  const [rewardValue, setRewardValue] = useState("5");

  const results = useMemo(() => {
    const earn = Math.max(0, parseFloat(pointsPerDollar) || 0);
    const needed = Math.max(0, parseFloat(pointsForReward) || 0);
    const value = Math.max(0, parseFloat(rewardValue) || 0);

    const pointValueCents = needed > 0 ? (value / needed) * 100 : 0;
    const spendNeeded = earn > 0 ? needed / earn : null;
    const rewardRate =
      spendNeeded && spendNeeded > 0 ? (value / spendNeeded) * 100 : 0;

    let verdict = "—";
    if (rewardRate > 0) {
      if (rewardRate < 3) verdict = "Too stingy";
      else if (rewardRate <= 10) verdict = "Healthy range";
      else verdict = "Margin risk";
    }

    return { pointValueCents, spendNeeded, rewardRate, verdict };
  }, [pointsPerDollar, pointsForReward, rewardValue]);

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
      {/* Inputs */}
      <div className="flex flex-col gap-5 bg-[#1E1E1E] border-2 border-white/10 rounded-2xl p-6 md:p-8">
        <h2 className="font-normal text-[24px] text-[#f8f7f4] tracking-[-0.5px]">
          Your earning &amp; redemption rules
        </h2>
        <Field
          label="Points earned per $1 spent"
          suffix="pts"
          value={pointsPerDollar}
          onChange={setPointsPerDollar}
          step="0.5"
        />
        <Field
          label="Points required for a reward"
          suffix="pts"
          value={pointsForReward}
          onChange={setPointsForReward}
        />
        <Field
          label="Value of that reward"
          suffix="USD"
          value={rewardValue}
          onChange={setRewardValue}
          step="0.01"
        />
        <p className="text-[13px] text-[#909090] leading-5">
          Example: 5 points per $1, a $5 coupon at 500 points → customers get
          5% back. Most healthy Shopify programs sit between 3% and 10%.
        </p>
      </div>

      {/* Results */}
      <div className="flex flex-col gap-4">
        <Stat
          label="Effective reward rate"
          value={fmtPct(results.rewardRate)}
          highlight
        />
        <Stat
          label="Program verdict"
          value={results.verdict}
        />
        <div className="grid grid-cols-2 gap-4">
          <Stat
            label="Value of 1 point"
            value={`${results.pointValueCents.toFixed(2)}¢`}
          />
          <Stat
            label="Spend needed for reward"
            value={
              results.spendNeeded === null ? "—" : fmtMoney(results.spendNeeded)
            }
          />
        </div>

        <a
          href="https://apps.shopify.com/keystone-loyalty-rewards?utm_source=website&utm_medium=organic&utm_campaign=points-value-calculator"
          className="mt-2 inline-flex items-center justify-center h-[52px] bg-[#dbdacd] border border-[#f8f7f4] rounded-[10px] px-6 text-base font-medium text-[#3e3e3e] hover:bg-[#cccbbe] transition-colors"
        >
          Launch these rules with Keystone Loyalty
        </a>
      </div>
    </div>
  );
}
